import React from 'react';
import PropTypes from 'prop-types';

export default function BuzzfeedFull({ size }) {
  return (
    <svg width={size} height="20" viewBox="0 0 113 20">
      <path
        d="M0,20V0H8.88c3.78,0,5.73,2.43,5.73,5.09a4.47,4.47,0,0,1-3.43,4.59A4.81,4.81,0,0,1,15,14.57c0,3-2,5.43-5.78,5.43ZM10.28,5.85A2.09,2.09,0,0,0,8,3.75H4.24V7.94H8A2.05,2.05,0,0,0,10.28,5.85Zm.4,8.12a2.28,2.28,0,0,0-2.54-2.28H4.24v4.56H8.15A2.21,2.21,0,0,0,10.67,14Zm5.32-.2V5h3.61v8.64a2.73,2.73,0,0,0,2.9,3,2.74,2.74,0,0,0,2.9-3V5H29v8.75C29,17.42,26.94,20,22.53,20S16,17.4,16,13.77ZM30,19V16.24l6.62-8H30V5H41.88V7.64l-6.75,8.14H42V19Zm13,0V16.24l6.62-8H43V5H54.88V7.64l-6.75,8.14H55V19Zm13,1V0H70V3.75H60.3V7.94h7.3v3.75H60.3V20Zm12-7.51A7.17,7.17,0,0,1,75.12,5C79.24,5,82,8.2,82,12.84v.88H71.78a3.73,3.73,0,0,0,4,3.2,5.66,5.66,0,0,0,3.64-1.39L81,18a8.38,8.38,0,0,1-5.66,2A7.1,7.1,0,0,1,68,12.49Zm7.12-4.41a3.22,3.22,0,0,0-3.37,3h6.78A3.2,3.2,0,0,0,75.12,8.08ZM84,12.49A7.17,7.17,0,0,1,91.12,5C95.24,5,98,8.2,98,12.84v.88H87.78a3.73,3.73,0,0,0,4,3.2,5.66,5.66,0,0,0,3.64-1.39L97,18a8.38,8.38,0,0,1-5.66,2A7.1,7.1,0,0,1,84,12.49Zm7.12-4.41a3.22,3.22,0,0,0-3.37,3h6.78A3.2,3.2,0,0,0,91.12,8.08ZM100,19V5h5.54c4.33,0,7.46,2.64,7.46,7s-3.11,7-7.44,7Zm9.49-7a3.66,3.66,0,0,0-3.81-4h-2.24v8h2.24A3.79,3.79,0,0,0,109.49,12Z"
        style={{ fill: '#e32' }}
      />
    </svg>
  );
}

BuzzfeedFull.propTypes = {
  size: PropTypes.number,
};

BuzzfeedFull.defaultProps = {
  size: 113,
};



// WEBPACK FOOTER //
// ./src/components/icons/BuzzfeedFull/index.js